import { r as registerInstance, h, H as Host } from './index-2b2e631a.js';
import { c as capitalise, g as getFieldValue } from './utils-9a999346.js';
import './state-3cc1e9a3.js';

let SearchResultUGCourse = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * Render element
   */
  render() {
    // Return element
    return (h(Host, { class: "search-result__inner" }, h("div", { class: "search-result__taxonomy" }, h("div", { class: "badge" }, "Undergraduate programme")), h("slot", null), h("div", { class: "search-result__meta" }, h("dl", null, h("dt", null, "Study options"), h("dd", null, capitalise(getFieldValue(this.searchResult.Fields, 'study_mode'))), h("dt", null, "UCAS code"), h("dd", null, getFieldValue(this.searchResult.Fields, 'ucas_code'))))));
  }
};

export { SearchResultUGCourse as search_result_ug_course };
